import type { UnlockEliteBannerUiVariant } from '@/components/home/UnlockEliteBanner/UnlockEliteBanner'

export const isLoyaltyDisplayStatusSuspended = (displayStatus?: string | null): boolean =>
    (displayStatus ?? '').trim().toUpperCase() === 'SUSPENDED'

// null => hide banner.
export const deriveBannerVariant = (
    loyaltyStatus: string | undefined,
    isSignedIn: boolean,
    displayStatus?: string
): UnlockEliteBannerUiVariant | null => {
    if (isLoyaltyDisplayStatusSuspended(displayStatus)) {
        return null
    }
    if (!isSignedIn) {
        return 'guest'
    }
    // Membership already earned and waiting to activate — hide unlock widget
    if (displayStatus?.toUpperCase() === 'ACTIVATING_SOON') {
        return null
    }
    switch (loyaltyStatus?.toUpperCase()) {
        case 'ACTIVE':
            return 'elite'
        case 'INACTIVE':
            return 'member_progress'
        default:
            return null
    }
}
